import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import {Md5} from 'ts-md5/dist/md5';
import { ElementRef, ViewChild, Inject } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';

@Component({
  selector: 'app-showalert',
  templateUrl: './showalert.component.html',
  styleUrls: ['./showalert.component.css']
})
export class ShowalertComponent implements OnInit {
    data1: any;
    title1: any;
    did: any;
    timer: any;
    counter = 60;
    uid: any;

  constructor(public dialogRef: MatDialogRef<ShowalertComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService) { 

        this.data1 = data.data1;

   
  }

  ngOnInit() {

  }




  close(){
    if (this.data1 === 'Doctor has accepted your request. Please proceed for payment'){
      this.dialogRef.close("Accepted");
    } else {
      this.dialogRef.close();
    }
  }

  



}